import styled from "styled-components";
import { Link } from "react-router-dom";
import { CardComp, ButtonComp } from "..";
import { formatMoney } from "../../utils/currencyFormat";
import { convertToTitleCase } from "../../utils/helpers";
import InvestorStatusBadge from "./InvestorStatusBadge";
import MarketplaceProductImage from "./MarketplaceProductImage";
import { investorButtonProps } from "./investorButtonStyles";

const ProductCardInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0;

  .product-category {
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--color-secondary);
    margin-bottom: 0.35rem;
  }

  .product-name {
    color: #383838;
    font-size: 1rem;
    line-height: 1.4;
    margin-bottom: 0.5rem;
  }

  .product-desc {
    font-size: 0.85rem;
    line-height: 1.55;
    color: #525252;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 1rem;
  }

  .product-meta {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.25rem;
  }

  .product-price {
    color: var(--color-primary);
    font-size: 1.05rem;
    font-weight: 700;
  }

  .product-unit {
    font-size: 0.75rem;
    color: #525252;
    margin-top: 0.15rem;
  }

  .product-actions {
    margin-top: auto;
    padding-top: 1.15rem;
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
  }
`;

export default function MarketplaceProductCard({ product, onOrder }) {
  const stockKey = product.stock?.replace(/_/g, " ") || "in stock";
  const detailPath = `/invest/marketplace/${product.slug || product.id}`;

  return (
    <CardComp
      noDefaultPadding
      cardClassName="border-0 shadow-sm rounded-4 h-100 investor-marketplace-card mb-0"
      cardBodyClassName="p-3 p-md-4"
    >
      <ProductCardInner>
        <Link to={detailPath} className="text-decoration-none">
          <MarketplaceProductImage product={product} />
        </Link>

        <p className="product-category">{product.category}</p>
        <h6 className="product-name fw-bold">{product.name}</h6>
        <p className="product-desc flex-grow-1">{product.description}</p>

        <div className="product-meta">
          <div>
            <span className="product-price d-block">{formatMoney(product.priceNgn)}</span>
            <span className="product-unit d-block">{product.unit}</span>
          </div>
          <InvestorStatusBadge status={product.stock || "in_stock"} label={convertToTitleCase(stockKey)} />
        </div>

        <div className="product-actions">
          <Link to={detailPath} className="w-100">
            <ButtonComp
              btnText="View details"
              btnClassName="w-100"
              {...investorButtonProps.outline}
              ButtonInlineStyle={{ ...investorButtonProps.outline.ButtonInlineStyle, width: "100%" }}
            />
          </Link>
          <ButtonComp
            btnText="Order"
            onClick={() => onOrder?.(product)}
            btnClassName="w-100"
            data-tour="invest-market-order"
            {...investorButtonProps.primary}
            ButtonInlineStyle={{ ...investorButtonProps.primary.ButtonInlineStyle, width: "100%" }}
          />
        </div>
      </ProductCardInner>
    </CardComp>
  );
}
